import { render, staticRenderFns } from "./combinationCourseList.vue?vue&type=template&id=66167e37&"
import script from "./combinationCourseList.vue?vue&type=script&lang=js&"
export * from "./combinationCourseList.vue?vue&type=script&lang=js&"
import style0 from "./combinationCourseList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports